'use client';

import * as React from 'react';
import { useShare } from '@/shared/hooks/use-share';
import * as Styled from './share-button.styled';
import { ShareIcon } from './share-icon';
interface ShareButtonProps {
  shareUrl: string;
  shareText: string;
}
export const ShareButton = React.memo(function ShareButton({
  shareUrl,
  shareText
}: ShareButtonProps) {
  const {
    canShare,
    share
  } = useShare(shareUrl);
  const handleShare = () => {
    if (canShare) {
      share();
    }
  };
  if (!canShare) {
    return null;
  }
  return <Styled.ShareButton type="button" onClick={handleShare} color="secondary" icon={ShareIcon}>
      {shareText}
    </Styled.ShareButton>;
});